// src/services/toast.service.ts
import { toast } from '@/hooks/use-toast';

export const ToastService = {
  error(message: string) {
    toast({
      title: "Eroare",
      variant: "destructive",
      description: message
    });
  },

  success(message: string, duration: number = 2000) {
    toast({
      title: "Succes",
      description: message,
      variant: "success",
      duration: duration
    });
  },

  // Poți adăuga și alte metode după necesitate
  info(message: string) {
    toast({
      title: "Info",
      description: message
    });
  }
};